import React, { useState } from 'react';
import './FilmCard.css';

export interface FilmCardData {
  id: string;
  title: string;
  location: string;
  videoImage: string;
  stillImage: string;
  isPlaceholder?: boolean;
}

interface FilmCardProps {
  film: FilmCardData;
  onClick?: () => void;
}

const FilmCard: React.FC<FilmCardProps> = ({ film, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className={`film-card ${film.isPlaceholder ? 'film-card--placeholder' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <div className="film-card__image-wrapper">
        {!film.isPlaceholder ? (
          <>
            {film.videoImage.includes('.mp4') ? (
              <video
                className={`film-card__video ${isHovered ? 'film-card__video--playing' : ''}`}
                src={film.videoImage}
                poster={film.stillImage}
                autoPlay
                muted
                loop
                playsInline
                onMouseEnter={(e) => e.currentTarget.play()}
                onMouseLeave={(e) => e.currentTarget.pause()}
              />
            ) : (
              <>
                <div 
                  className={`film-card__image ${isHovered ? 'film-card__image--hovered' : ''}`}
                  style={{ backgroundImage: `url(${film.videoImage})` }}
                />
                <div 
                  className={`film-card__still ${isHovered ? 'film-card__still--visible' : ''}`}
                  style={{ backgroundImage: `url(${film.stillImage})` }}
                />
              </>
            )}
          </>
        ) : (
          <div className="film-card__placeholder" />
        )}
      </div>
      <div className="film-card__info">
        <h3 className="film-card__title">{film.title}</h3>
        <span className="film-card__location">{film.location}</span>
      </div>
    </div>
  );
};

export default FilmCard;